import request from "@/untils/request.js";
//获取热门直播
export function liveCaregoryList() {
  return request({
    url: "/live/category/all",
    method: "get",
  });
}
